module.exports = __webpack_public_path__ + "img/02.d1cc237b.jpg";